import { ClientdashboardDetailsApi } from "../../api/client/ClientDashboard";

export const CLIENT_DASHBOARD_DETAILS = "CLIENT_DASHBOARD_DETAILS";

/**
 * Get user work list action
 * @param {Object} data
 * @returns
 */
const ClientDashboard = (data) => ({
  type: CLIENT_DASHBOARD_DETAILS,
  data,
});

export const ClientdashboardDetails =
  (setLoading, setError) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await ClientdashboardDetailsApi();
      if (response.success) {
        dispatch(ClientDashboard(response.data));
        setLoading(false);
      } else {
        setLoading(false);
        setError("Oops! Failed to load dashboard details");
      }
    } catch (error) {
      setLoading(false);
      setError("Oops! Something went wrong");
    }
  };
